/**
 * Shared layout primitives for the RMA (Returns) detail and form surfaces.
 *
 * SectionCard groups a logical chunk of an RMA into a titled card; DetailRow
 * renders a label/value pair inside one. Used by the read-only summary and by
 * the create / edit / process forms so all four surfaces share one visual
 * language.
 *
 * Contains:
 * - SectionCard — titled card wrapper
 * - DetailRow   — label/value (or label/children) row
 */
import { Box, Card, CardContent, Typography } from '@mui/material';
import React from 'react';

export function DetailRow({ label, value, children }) {
  const content = children ?? value;
  if (content == null || content === '') return null;
  return (
    <Box sx={{ display: 'flex', gap: 1, py: 0.5, alignItems: 'flex-start' }}>
      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 160, flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography variant="body2" component="div" sx={{ overflowWrap: 'anywhere' }}>
        {content}
      </Typography>
    </Box>
  );
}

export function SectionCard({ title, children, sx }) {
  return (
    <Card sx={{ mb: 2, ...sx }}>
      <CardContent>
        {title ? (
          <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            {title}
          </Typography>
        ) : null}
        {children}
      </CardContent>
    </Card>
  );
}
